import { Component, OnInit, Output, Injectable, DebugElement } from '@angular/core';
import { UtilityServices, CheckAuth } from '../Services/UtilityService';
import { Router, NavigationStart } from '@angular/router';


@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  appModel: any;
  showMenu: boolean;

  constructor(private utility: UtilityServices, private router: Router, private checkAuth: CheckAuth) {
    
  }

  ngOnInit(): void {    
  }
}
